import { useMemo } from 'react';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { corporateUserService } from 'corporate/services';
import { IPricingProfileAdminUser } from 'pricing/types';

import { IPricingProfileAdminUserForm } from './types';

interface IProps {
  pricingProfileAdminUser?: IPricingProfileAdminUser;
  isOpen: boolean;
  onClose: (reset?: UseFormReset<IPricingProfileAdminUserForm>) => void;
  onSubmit: (
    reset: UseFormReset<IPricingProfileAdminUserForm>
  ) => (data: IPricingProfileAdminUserForm) => void;
}

export const UpsertPricingProfileAdminUserFormFields = ({
  pricingProfileAdminUser,
  isOpen,
  onClose,
  onSubmit,
}: IProps) => {
  const { t } = useTranslation();

  const title = useMemo(
    () => (pricingProfileAdminUser ? t('titleUpdateAdminUser') : t('titleAddAdminUser')),
    [pricingProfileAdminUser, t]
  );

  return (
    <Form title={title} isOpen={isOpen} onClose={onClose} onSubmit={onSubmit}>
      <FormField
        name="corporateUser"
        type={InputType.AUTOCOMPLETE}
        inputProps={{
          label: t('labelUser'),
          placeholder: t('placeholderSelectUser'),
          getOptions: corporateUserService.getCorporateUsersAutocomplete,
          disableClearable: true,
          required: true,
        }}
      />
    </Form>
  );
};
